export const supportedLocales = ["en", "pt-BR", "pt-PT", "es"] as const;
export type Locale = (typeof supportedLocales)[number];
export const defaultLocale: Locale = "en";
export const fallbackLocale: Locale = "en";

export function isLocale(value: string | null | undefined): value is Locale {
  return supportedLocales.some((locale) => locale === value);
}

export function resolveLocale(
  values: readonly (string | null | undefined)[],
): Locale {
  for (const value of values) {
    if (isLocale(value)) return value;
    const base = value?.split(/[-_]/)[0];
    if (base === "pt") {
      const region = value?.split(/[-_]/)[1]?.toUpperCase();
      if (region === "PT") return "pt-PT";
      return "pt-BR";
    }
    if (base === "es") return "es";
    if (base === "en") return "en";
  }
  return fallbackLocale;
}

export function formatDate(
  value: Date,
  locale: Locale,
  timeZone: string,
): string {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeZone,
  }).format(value);
}

export function formatTime(
  value: Date,
  locale: Locale,
  timeZone: string,
): string {
  return new Intl.DateTimeFormat(locale, {
    timeStyle: "short",
    timeZone,
  }).format(value);
}

export function formatPeriod(
  start: Date,
  end: Date,
  locale: Locale,
  timeZone: string,
): string {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeZone,
  }).formatRange(start, end);
}

export function formatCurrency(
  value: number,
  currency: string,
  locale: Locale,
): string {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    value,
  );
}
